import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowboardNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.349 1.047a3.256 3.256 0 114.604 4.604c-.743.743-1.614 1.496-2.465 2.231l-.01.009c-.862.745-1.7 1.47-2.408 2.178-.707.707-1.433 1.546-2.178 2.408l-.009.01c-.735.85-1.488 1.722-2.23 2.465a3.256 3.256 0 01-4.605-4.604l.001-.001.008-.008c.74-.74 1.609-1.49 2.456-2.222l.015-.013c.86-.744 1.697-1.468 2.403-2.174s1.43-1.543 2.174-2.403l.013-.015C8.85 2.665 9.6 1.797 10.34 1.056l.008-.008zm.883.884l-.007.007c-.706.707-1.431 1.546-2.175 2.406l-.178.207a.999.999 0 01.76.17l1.65 1.178a1 1 0 01.395 1.032c.856-.74 1.689-1.46 2.392-2.164a2.006 2.006 0 10-2.837-2.836zM6.816 6.814c-.435.435-.914.873-1.407 1.31.247-.014.5.063.702.235l1.532 1.296a.997.997 0 01.353.803c.397-.446.796-.878 1.191-1.273.375-.375.782-.752 1.204-1.129a.997.997 0 01-.74-.292L8.236 6.35a.997.997 0 01-.293-.74 29.8 29.8 0 01-1.128 1.204zM4.373 9.025l-.022.02-.006.004c-.86.744-1.698 1.468-2.405 2.175l-.008.008a2.006 2.006 0 002.836 2.836c.686-.685 1.388-1.494 2.108-2.327a1 1 0 01-.992-.328L4.588 9.88a1 1 0 01-.215-.856z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowboardNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowboardNormalXsmall;
